import { useState, useEffect } from "react"
import PropTypes from "prop-types"
import MenuIcon from "@mui/icons-material/Menu"
import { connect } from "react-redux"
import { NotificationsNone } from "@mui/icons-material"
import { styled } from "@mui/material/styles"
import { useHistory } from "react-router-dom"
import { PERMISSIONS } from "../../constants/permissions.js"

import {
    Divider,
    Badge,
    AppBar,
    Toolbar,
    IconButton,
    Grid,
    Typography,
    ListItemText,
    MenuItem,
    Menu,
} from "@mui/material"
import * as userProfileActions from "../../redux/userProfile/actions"
import * as carOrderActions from "../../redux/carOrder/actions"

import { AccountCircle } from "@mui/icons-material"
import { useOktaAuth } from "@okta/okta-react"
import config from "../../constants/auth-config"
import {
    getStoredShipper,
    loadChatBot,
    unLoadChatBot,
    checkRailRoad,
} from "../../constants/utils"

import { RAIL_ROADS, URLS } from "../../constants/values"
import { getIndexDBconfig } from "../../constants/IndexDBConfig.js"
import userProfileApi from "../../api/user-profile-api"

import { labels } from "../../constants/labels"

import RailroadSearchDropdown from "../RailroadSearchDropdown"
import FaqReleaseNote from "../FaqReleaseNote"
const { VITE_APP_ENHANCED_VISIBILITY, VITE_APP_PRODUCT_HUB } = import.meta.env

const issuer = config().issuer
const redirectUri = `${window.location.origin}`

const StyledAppBar = styled(AppBar)({
    minHeight: "47px",
})

const StyledMenuIcon = styled(MenuIcon)({
    cursor: "pointer",
})

const LogoGrid = styled(Grid)({
    margin: 0,
    padding: 0,
})

const StyledLogoButton = styled(IconButton)({
    margin: 0,
    padding: 0,
    "& img": {
        height: "55px !important",
        width: "105px !important",
    },
})

const TitleGrid = styled(Grid)({
    color: "#007acc",
    paddingLeft: "7px !important",
})

const ShadowBar = styled(Grid)({
    padding: "0px !important",
    width: "14px",
    height: "75px",
    transform: "translate(10px, -12px) rotate(20deg)",
    boxShadow: "rgb(186, 190, 193) 8px -2px 8px -5px",
})

const ProfileGrid = styled(Grid)({
    marginLeft: "auto !important",
})

const StyledToolbar = styled(Toolbar)({
    backgroundColor: "white",
})

const StyledMenu = styled(Menu)({
    "& .MuiPaper-root": {
        border: "1px solid #d3d4d5",
    },
})

const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
    "&:focus": {
        backgroundColor: theme.palette.primary.main,
        "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
            color: theme.palette.common.white,
        },
    },
}))

const Navbar = (props) => {
    const [anchorEl, setAnchorEl] = useState(null)
    const isMenuOpen = Boolean(anchorEl)

    const { authState, oktaAuth } = useOktaAuth()
    const {
        logo,
        projectName,
        userProfileData,
        showNavbar,
        toggleNavbar,
        selectShipper,
        fetchAllTracks,
        checkEbolWOAccess,
    } = props

    const history = useHistory()

    useEffect(() => {
        const handleStorageChange = (event) => {
            if (event.key === "logoutEvent" && event.newValue) {
                handleLogoutEvent()
            }
        }

        window.addEventListener("storage", handleStorageChange)

        return () => {
            window.removeEventListener("storage", handleStorageChange)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (authState && authState.isAuthenticated) {
            localStorage.setItem("isAuthorized", JSON.stringify(true))
            localStorage.setItem("loginEvent", Date.now())
        } else if (authState && !authState.isAuthenticated) {
            setTimeout(() => {
                window.location.href = VITE_APP_PRODUCT_HUB
            }, 500)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authState])

    const { SHIPPER, STORED_SHIPPER_NAME, STORED_RAILROAD_NAME } =
        getStoredShipper()

    const allShippers =
        userProfileData && userProfileData.length
            ? userProfileData
                  .filter(
                      (item) =>
                          item.orgType === "Shipper" && item.grantors.length > 0
                  )
                  .sort((a, b) => {
                      let railroadA =
                          a.grantors && a.grantors.length > 0
                              ? a.grantors[0]["orgName"]
                              : ""
                      let railroadB =
                          b.grantors && b.grantors.length > 0
                              ? b.grantors[0]["orgName"]
                              : ""
                      let railroad_order = railroadA
                          .toLowerCase()
                          .localeCompare(railroadB.toLowerCase())
                      let shipper_order = a.orgName
                          .toLowerCase()
                          .localeCompare(b.orgName.toLowerCase())
                      return railroad_order || shipper_order
                  })
            : []

    const handleProfileMenuOpen = (event) => {
        setAnchorEl(event.currentTarget)
    }

    const handleMenuClose = () => {
        setAnchorEl(null)
    }

    const handleLogoutEvent = () => {
        localStorage.setItem("isAuthorized", JSON.stringify(false))
        setTimeout(() => {
            window.location.href = VITE_APP_PRODUCT_HUB
        }, 500)
    }
    const handleLogout = () => {
        setAnchorEl(null)
        //localStorage.clear()
        // localStorage.setItem("shipper_details", JSON.stringify(SHIPPER))

        //---------- clear indexDB --------------
        const { DB_NAME, DB_STORE_NAME, DB_VERSION } = getIndexDBconfig()
        const requestDB = indexedDB.open(DB_NAME, DB_VERSION)

        let db

        requestDB.onsuccess = () => {
            db = requestDB.result
            const objectStore = db
                .transaction([DB_STORE_NAME])
                .objectStore(DB_STORE_NAME)
            objectStore.clear()
        }
        //--------

        // Trigger logout event across tabs
        localStorage.setItem("logoutEvent", Date.now())

        setTimeout(() => {
            window.location.href = VITE_APP_PRODUCT_HUB
        }, 500)
    }

    const handleSelectedAction = async (shipper) => {
        const { fetchAccessRightsSuccess } = props
        const previousShipper = JSON.parse(
            localStorage.getItem("shipper_details")
        )
        localStorage.setItem("shipper_details", JSON.stringify(shipper))

        const accessRights =
            await userProfileApi.getAccessRightsData(allShippers)

        const permissions = accessRights.permissions
        if (
            permissions.length === 1 &&
            permissions[0].permissionName ===
                PERMISSIONS.CAN_ACCESS_ENHANCED_VISIBILITY_MODULE
        ) {
            localStorage.setItem(
                "shipper_details",
                JSON.stringify(previousShipper)
            )
            window.location.href = VITE_APP_ENHANCED_VISIBILITY
            return
        }

        checkEbolWOAccess()
        if (
            [
                URLS.CREATE_CAR_ORDER,
                URLS.GENERAL_PLACEMENT_NEW_REQUEST,
                URLS.INVENTORY,
            ].indexOf(location.pathname) > -1
        ) {
            fetchAllTracks()
        }

        fetchAccessRightsSuccess(accessRights, allShippers)

        if (checkRailRoad([...RAIL_ROADS])) loadChatBot()
        else unLoadChatBot()

        handleMenuClose()
        selectShipper(shipper)
    }

    const renderMenu = (
        <StyledMenu
            id="customized-menu"
            anchorEl={anchorEl}
            keepMounted
            open={isMenuOpen}
            onClose={handleMenuClose}
            elevation={0}
            anchorOrigin={{
                vertical: "bottom",
                horizontal: "center",
            }}
            transformOrigin={{
                vertical: "top",
                horizontal: "center",
            }}
        >
            <MenuItem>
                {JSON.parse(localStorage.getItem("okta-token-storage")) &&
                JSON.parse(localStorage.getItem("okta-token-storage")).idToken
                    ? JSON.parse(localStorage.getItem("okta-token-storage"))
                          .idToken.claims.email
                    : ""}
            </MenuItem>
            <Divider variant="middle" />
            <StyledMenuItem onClick={handleLogout}>
                <ListItemText primary={labels.common.logout} />
            </StyledMenuItem>
        </StyledMenu>
    )

    return (
        <div id="main-app">
            <StyledAppBar color="default" position="static">
                <StyledToolbar position="static" variant="dense">
                    <Grid
                        container
                        direction="row"
                        spacing={4}
                        alignItems="center"
                    >
                        <Grid item>
                            <StyledMenuIcon
                                onClick={() => toggleNavbar(!showNavbar)}
                                data-test="menu_icon"
                            />
                        </Grid>
                        <LogoGrid item>
                            <StyledLogoButton
                                edge="start"
                                color="inherit"
                                aria-label="open drawer"
                                onClick={() => history.push("/")}
                                size="large"
                            >
                                <img src={logo} alt="Wabtec" />
                            </StyledLogoButton>
                        </LogoGrid>
                        <TitleGrid item>
                            <Typography variant="subtitle2">
                                <b>{projectName}</b>
                            </Typography>
                        </TitleGrid>
                        <ShadowBar item />

                        <ProfileGrid item>
                            <Grid
                                container
                                direction="row"
                                justifyContent="center"
                                alignItems="center"
                            >
                                <Grid item>
                                    <RailroadSearchDropdown
                                        allShippersProfile={allShippers}
                                        storedShipper={
                                            allShippers &&
                                            allShippers.length > 0
                                                ? STORED_SHIPPER_NAME
                                                : ""
                                        }
                                        storedRailRoad={
                                            allShippers &&
                                            allShippers.length > 0
                                                ? STORED_RAILROAD_NAME
                                                : ""
                                        }
                                        handleRailRoadChanges={
                                            handleSelectedAction
                                        }
                                    />
                                </Grid>

                                <FaqReleaseNote />

                                <Grid item>
                                    <IconButton
                                        color="inherit"
                                        disabled
                                        size="large"
                                    >
                                        <Badge color="secondary">
                                            <NotificationsNone />
                                        </Badge>
                                    </IconButton>
                                </Grid>

                                <Grid item>
                                    <IconButton
                                        edge="end"
                                        aria-label="account of current user"
                                        aria-haspopup="true"
                                        color="inherit"
                                        onClick={handleProfileMenuOpen}
                                        size="large"
                                    >
                                        <AccountCircle />
                                    </IconButton>
                                </Grid>
                            </Grid>
                        </ProfileGrid>
                    </Grid>
                </StyledToolbar>
            </StyledAppBar>
            {renderMenu}
        </div>
    )
}
Navbar.propTypes = {
    navItems: PropTypes.arrayOf(PropTypes.object),
    projectName: PropTypes.string.isRequired,
    logo: PropTypes.string.isRequired,
    userProfileData: PropTypes.arrayOf(PropTypes.object).isRequired,
}
Navbar.defaultProps = {}

const mapDispatchToProps = {
    fetchAccessRightsSuccess: userProfileActions.fetchAccessRightsSuccess,
    selectShipper: userProfileActions.selectShipper,
    fetchAllTracks: carOrderActions.fetchShipperTracks,
    checkEbolWOAccess: userProfileActions.checkEbolWOAccess,
}

export default connect(null, mapDispatchToProps)(Navbar)
